import Papa from "papaparse";
import { isValidRowSensorsCSVReader } from "../../../../../../validators/csvValidators";
import { Sensor, SensorCSVRow } from "features/iot/sensors/models/sensor-models";
import { SBSensor } from "features/iot/sensor-batch/models/sensor-batch-models";
import { getTodayDateString } from "components/utils/date-formatter-utils";

const SensorCSVReader = (file: File): Promise<SensorCSVRow[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const csvData = event.target?.result;
      if (typeof csvData !== "string") {
        reject(new Error("File content is not a string"));
        return;
      }

      Papa.parse(csvData, {
        header: false,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: function (result: { data: any[] }) {
          const invalidRows = result.data.filter(
            (row) => !isValidRowSensorsCSVReader(row)
          );
          if (invalidRows.length > 0) {
            reject(new Error("Invalid rows detected"));
            return;
          }

          const rows: SensorCSVRow[] = result.data.map((row: any) => ({
            serialNumber: row[0],
            macAddress: row[1],
            isManufactured: row[2].toLowerCase() === "true",
            manufacturedDate: row[3] ?? getTodayDateString(),
            firmwareRevision: row[4],
            hardwareRevision: row[5],
            numberOfResistiveElements: parseFloat(row[6]) || 0,
            offset: parseFloat(row[7]) || 0,
            pitch: parseFloat(row[8]) || 0,
          }));
          resolve(rows);
        },
      });
    };

    reader.onerror = function () {
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};
export default SensorCSVReader;

export const ConvertSensorsToCsv = (sensors: SBSensor[] | Sensor[]): string => {
  const header = ["serialNumber", "macAddress"];
  const csvRows = [header.join(",")];

  sensors.forEach((sensor) => {
    const row = [sensor.serialNumber, sensor.macAddress];
    csvRows.push(row.join(","));
  });

  return csvRows.join("\n");
};
